<template>
  <b-modal
    :active="true"
    :can-cancel="['escape', 'x', 'outside']"
    @close="onClose"
  >
    <div class="content">
      <div class="header">
        <h1 class="title">Documents</h1>
        <b-field class="file is-primary">
          <b-upload v-model="files" multiple class="file-label">
            <span class="file-cta">
              <b-icon class="file-icon" icon="upload"></b-icon>
              <span class="file-label">Click to upload</span>
            </span>
          </b-upload>
        </b-field>
      </div>
      <div style="flex-grow: 1; overflow-y: auto" class="table-container">
        <b-table
          :data="documents"
          :narrowed="true"
          :loading="isLoading"
          :paginated="documents.length > 20 ? true : false"
          :per-page="20"
          @click="onRowClick"
        >
          <template slot-scope="props">
            <b-table-column
              field="originalFileName"
              label=" File Name"
              sortable
            >
              {{ props.row.originalFileName }}
            </b-table-column>
            <b-table-column>
              <div style="display: flex; gap: 5px" @click.stop>
                <b-button
                  type="is-danger"
                  icon-right="delete"
                  @click="onDelete(props.row)"
                />
              </div>
            </b-table-column>
          </template>
          <template #empty>
            <div class="has-text-centered">No records</div>
          </template>
        </b-table>
      </div>
      <footer class="footer-buttons">
        <b-button label="Close" @click="onClose" />
      </footer>
    </div>
  </b-modal>
</template>
<script>
import client from '../../../config/api';
import DIJVueConfigurations from '../../../helpers/DIJVueConfigurations';

export default {
  name: 'InstrumentDocumentsModal',
  props: {
    instrumentation: {
      type: Object,
      default: null,
    },
  },

  watch: {
    async files(newFiles) {
      if (newFiles && newFiles.length > 0) {
        try {
          this.isLoading = true;
          // eslint-disable-next-line no-restricted-syntax
          for (const file of newFiles) {
            // eslint-disable-next-line no-await-in-loop
            await this.uploadFile(file);
          }
        } catch (error) {
          console.error('Error uploading file:', error);
        } finally {
          this.isLoading = false;
        }
      }
    },
  },

  data() {
    return {
      files: [],
      isLoading: false,
      documents: this.instrumentation.documents || [],
    };
  },
  methods: {
    async uploadFile(file) {
      const fileName = file.name;
      const response = await client.post(
        `/instrumentations/presign-upload-file/${this.instrumentation._id}`,
        { fileName }
      );
      const { presignedPostData, path, uniqueFileName } = response.data;
      const dijConfigurations = new DIJVueConfigurations();
      await dijConfigurations.sendPresignedPostData(
        presignedPostData,
        file,
        file.name
      );

      const newDocument = {
        fileName: uniqueFileName,
        originalFileName: fileName,
        path,
      };
      this.documents.push(newDocument);

      this.$emit('onUpdate', {
        documents: this.documents,
      });
      this.files = [];
    },
    async onRowClick(row) {
      try {
        this.isLoading = true;
        const downloadUrlResponse = await client.post(
          '/instrumentations/presign-download-file',
          { path: row.path }
        );
        const downloadUrl = downloadUrlResponse.data;

        window.open(downloadUrl, '_blank');
      } catch (error) {
        console.error('Error generating download URL:', error);
      } finally {
        this.isLoading = false;
      }
    },

    onDelete(document) {
      this.$buefy.dialog.confirm({
        title: 'Deleting Document',
        message: `Are you sure you want to <b>delete</b> Document : ${document.originalFileName}? This action cannot be undone.`,
        confirmText: 'Delete Document',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.onDeleteDocument(document);
        },
      });
    },

    async onDeleteDocument(document) {
      this.documents = this.documents.filter(
        (doc) => doc.path !== document.path
      );
      this.$emit('onUpdate', {
        documents: this.documents,
      });
    },

    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  min-height: 500px;
  justify-content: space-between;
}

.header {
  display: flex;
  justify-content: space-between;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.table-container {
  flex-grow: 1;
}
td {
  cursor: pointer;
}
</style>
